import { Injectable } from '@angular/core';
import { SelectItem } from '@web/shared/ui';
import { Observable, of } from 'rxjs';
import { PublicProductSortType } from '../enums/public-product-sort-type';

@Injectable({
  providedIn: 'root',
})
export class PublicProductSortTypeSelectItemsProviderService {
  private readonly entries = new Map<PublicProductSortType, string>([
    [PublicProductSortType.NameAscending, 'Nazwa rosnąco'],
    [PublicProductSortType.NameDescending, 'Nazwa malejąco'],
    [PublicProductSortType.CreatedAtAscending, 'Najstarsze'],
    [PublicProductSortType.CreatedAtDescending, 'Najnowsze'],
  ]);

  public selectItems(): Observable<SelectItem<PublicProductSortType>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) => new SelectItem<PublicProductSortType>(label, type),
      ),
    );
  }
}
